import React from 'react';
import { Button } from 'antd';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnyCriteria } from '../../types/AlertConfiguration';
import { AlertCriteriaProps, CriteriaError, AlertCriteria } from '../AlertCriteria';
import { Icons } from 'src/components/common/icons';
import styles from './BlockOr.module.less';

type Props = {
  criteria: AnyCriteria;
  error?: CriteriaError | null;
  indexOr: number;
  onRemove: () => void;
  onCriteriaChange: AlertCriteriaProps['onCriteriaChange'];
  onCriteriaCopy: (criteria: AnyCriteria) => void;
  isOrVisible: boolean;
  setCopiedError: (error: CriteriaError | null) => void;
  onCriteriaPaste: (indexAnd: number, indexOr: number) => void;
  isCopiedCriteria: boolean;
  indexAnd: number;
};

const ButtonGroup = Button.Group;

export const BlockOr: React.FC<Props> = ({
  criteria,
  error,
  indexOr,
  onRemove,
  onCriteriaChange,
  isOrVisible,
  onCriteriaCopy,
  setCopiedError,
  onCriteriaPaste,
  indexAnd,
  isCopiedCriteria,
}) => {

  return (
    <div className={styles.chainBlock}>
      <div className={styles.xSpaceBetween}>
        {indexOr > 0 ? <p className={styles.text}>OR</p> : <div />}
        <FontAwesomeIcon icon={['fal', 'times']} onClick={onRemove} className={styles.closeIcon} size={'lg'} />
      </div>
      <AlertCriteria criteria={criteria} error={error} onCriteriaChange={onCriteriaChange} />
      {isOrVisible && (
        <div className={styles.xSpaceBetween}>
          <div />
          <ButtonGroup className={styles.xRow}>
            <Button
              className={clsx(styles.btnCopyPast, styles.rightLine)}
              title="Copy"
              onClick={() => {
                onCriteriaCopy(criteria);
                setCopiedError(error || null);
              }}
            >
              <Icons.Copy className={styles.iconPaste} />
            </Button>
            <Button
              disabled={!isCopiedCriteria}
              className={styles.btnCopyPast}
              title="Paste"
              onClick={() => onCriteriaPaste(indexAnd, indexOr)}
            >
              <Icons.Paste className={styles.iconPaste} />
            </Button>
          </ButtonGroup>
        </div>
      )}
    </div>
  );
};
